if (!customElements.get('showcase-section')) {
    class ShowcaseSection extends HTMLElement {
        constructor() {
            super();
            this.swiper = null;
            this.listSwiperContainer = this.querySelector('.showcase-section__items-list');
            this.items = this.querySelectorAll('.showcase-item');
            this.popupContainer = this.querySelector('.showcase-section__popup-container');
            this.closePopupButton = this.querySelector('.showcase-section__popup__dialog-close-button');
            this.mainSection = document.querySelector('.showcase-section[data-main="true"]');

            if (this.closePopupButton && this.popupContainer) {
                this.closePopupButton.addEventListener('click', () => {
                    this.popupContainer.classList.remove('active');
                });
                this.popupContainer.addEventListener('click', (event) => {
                    if (event.target === this.popupContainer) {
                        this.popupContainer.classList.remove('active');
                    }
                });
            }
        }

        connectedCallback() {
            if (this.listSwiperContainer) {
                this.initListSwiper();
            }
            if (this.items.length > 0) {
                this.downloadCountFunction();
                this.clickEventFunction();
            }

            if (this.mainSection && !this.mainSection._merged && this.dataset.main === 'true') {
                // console.log('主要模块执行 mergeItems()');
                this.mergeItems();
            }
        }

        mergeItems() {
            if (this._merged) return;
            this._merged = true;

            const otherSections = document.querySelectorAll('.showcase-section[data-main="false"]');
            const mainSectionContainer = this.querySelector('.swiper-wrapper');
            if (!mainSectionContainer) return;

            otherSections.forEach(section => {
                const items = section.querySelectorAll('.showcase-item');
                items.forEach(item => {
                    mainSectionContainer.appendChild(item.cloneNode(true));
                });
            });

            otherSections.forEach(section => {
                section.style.display = 'none';
            });
        }

        initListSwiper() {
            const scrollbar = this.listSwiperContainer.querySelector('.swiper-scrollbar');
            this.swiper = new Swiper(this.listSwiperContainer, {
                slidesPerView: 4,
                spaceBetween: 16,
                grid: {
                    fill: 'row',
                    rows: 2,
                },
                scrollbar: {
                    el: scrollbar,
                    draggable: true,
                },
                breakpoints: {
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1001: { slidesPerView: 3 },
                    1441: { slidesPerView: 4 },
                },
            });
        }

        downloadCountFunction() {
            this.items.forEach(item => {
                const countElem = item.querySelector('.showcase-item__object-download-count');
                if (countElem) {
                    const rawText = countElem.textContent;
                    const num = parseInt(rawText.replace(/,/g, ''), 10);
                    if (!isNaN(num)) {
                        countElem.textContent = num.toLocaleString();
                    }
                }
            });
        }

        clickEventFunction() {
            if (!this.listSwiperContainer) return;
            this.listSwiperContainer.addEventListener('click', (event) => {
                const item = event.target.closest('.showcase-item');
                if (!item || !this.listSwiperContainer.contains(item)) return;

                if (event.target.closest('.showcase-item__object')) return;

                if (event.target.closest('.showcase-item__made-by-link')) return;

                this.itemClicked(item, event);
            });
        }

        _updatePopupContent(content, targetEl) {
            const updateField = (el, value) => {
                if (!el) return;
                el.textContent = value;
                const outer = el.closest('.showcase-section__popup__dialog-content__box__outer');
                if (outer) {
                    outer.classList.toggle('hide', !value);
                }
            };

            updateField(targetEl.title, content.title);
            updateField(targetEl.author, content.author);
            updateField(targetEl.date, content.date);
            updateField(targetEl.info, content.info);
            updateField(targetEl.fileSize, content.fileSize);

            if (targetEl.madeBy) {
                const madeBySection = targetEl.madeBy.closest('[data-made-by-section]');
                if (content.madeBy) {
                    if (content.madeByUrl) {
                        const link = document.createElement('a');
                        link.href = content.madeByUrl;
                        link.textContent = content.madeBy;
                        targetEl.madeBy.innerHTML = '';
                        targetEl.madeBy.appendChild(link);
                    } else {
                        targetEl.madeBy.textContent = content.madeBy;
                    }
                    if (targetEl.madeByBtn && content.madeByUrl) {
                        targetEl.madeByBtn.href = content.madeByUrl;
                    }
                    if (madeBySection) madeBySection.style.display = 'flex';
                } else {
                    if (madeBySection) madeBySection.style.display = 'none';
                }
            }

            if (targetEl.url) {
                if (content.url) {
                    targetEl.url.href = content.url;
                    targetEl.url.setAttribute('download', content.title);
                    targetEl.url.classList.remove('hide');
                } else {
                    targetEl.url.classList.add('hide');
                }
            }
        }

        async _handlePopupImages(imagesEl, targetImagesEl) {
            if (!imagesEl || !targetImagesEl) return;

            const swiperWrapper = targetImagesEl.querySelector('.swiper-wrapper');
            if (!swiperWrapper) return;

            swiperWrapper.innerHTML = '';
            const fragment = document.createDocumentFragment();
            for (const child of imagesEl.children) {
                if (child.nodeType === Node.ELEMENT_NODE) {
                    fragment.appendChild(child.cloneNode(true));
                }
            }
            swiperWrapper.appendChild(fragment);

            if (typeof Swiper !== 'undefined') {
                if (targetImagesEl.swiper) {
                    targetImagesEl.swiper.destroy(true, true);
                }
                targetImagesEl.swiper = new Swiper(targetImagesEl, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    navigation: {
                        nextEl: targetImagesEl.querySelector('.swiper-button-next'),
                        prevEl: targetImagesEl.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: targetImagesEl.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                });
            }
        }

        itemClicked(item) {
            if (!this.popupContainer) return;
            this.popupContainer.classList.add('active');

            const infoEl = item.querySelector('.showcase-item__info');
            if (!infoEl) return;

            const content = {
                title: infoEl.dataset.title || '',
                author: infoEl.dataset.author || '',
                date: infoEl.dataset.date || '',
                info: infoEl.dataset.info || '',
                url: infoEl.dataset.url || '',
                madeBy: infoEl.dataset.madeBy || '',
                madeByUrl: infoEl.dataset.madeByUrl || '',
                fileSize: infoEl.dataset.fileSize || '',
            };

            const imagesEl = item.querySelector('.showcase-item-image');
            const targetEl = {
                title: this.popupContainer.querySelector('.showcase-section__popup__dialog-title'),
                author: this.popupContainer.querySelector('.showcase-section__popup__dialog-content__box__author'),
                date: this.popupContainer.querySelector('.showcase-section__popup__dialog-content__box__date'),
                info: this.popupContainer.querySelector('[data-info-content]'),
                url: this.popupContainer.querySelector('.showcase-section__popup__dialog-content__box__download'),
                images: this.popupContainer.querySelector('.showcase-section__popup__dialog-content__images'),
                madeBy: this.popupContainer.querySelector('[data-made-by-title]'),
                madeByBtn: this.popupContainer.querySelector('[data-made-by-url]'),
                fileSize: this.popupContainer.querySelector('[data-file-size-content]'),
            };

            this._updatePopupContent(content, targetEl);
            this._handlePopupImages(imagesEl, targetEl.images);
        }

        disconnectedCallback() {
        }
    }

    customElements.define('showcase-section', ShowcaseSection);
}
